import { ParentEvent, ViewerModule } from '@g.frame/core';
import { Color, Vector2 } from 'three';
import { TextComponent } from '@g.frame/components.text';
import { ActionControllerEventName } from '@g.frame/common.action_controller';
import { WindowComponent } from "@g.frame/components.window";
const styleConfig = {
    backColor: new Color('#9DC458'),
    shadowColor: new Color('#5D772E'),
    text: {
        color: new Color('#FFFFFF'),
    }
};
export default class TextButtonElement extends ViewerModule {
    constructor(loader, actionController, textComponentFactory) {
        super();
        this.loader = loader;
        this.actionController = actionController;
        this.textComponentFactory = textComponentFactory;
        // this.loader.addResources([
        //     {
        //         name: 'ProximaNova&ttf-600-normal',
        //         url: require('../../../../assets/fonts/Ubuntu-Bold.ttf'),
        //         type: FONT
        //     },
        // ]);
        this.actionController.on(ActionControllerEventName.click, this.uiObject, (event) => {
            if (event.data.intersection.orderNumber !== 0)
                return;
            this.fire('click', new ParentEvent('click'));
        });
        this.uiObject.name = 'TextButton';
    }
    set(newOptions) {
        if (newOptions) {
            this.oldOptions = this.options;
            this.options = newOptions;
        }
        this.button && this.disposeObject(this.button);
        this.background && this.disposeObject(this.background);
        this.backgroundBorder && this.disposeObject(this.backgroundBorder);
        this.resultSize = this.options.window.size.clone().multiplyScalar(this.options.window.scale);
        this.initButton();
    }
    initButton() {
        if (!this.options.text)
            return;
        const buttonSize = this.resultSize.clone().addScalar(-this.resultSize.y / 5);
        this.addObject(this.button = this.textComponentFactory.getFactory(TextComponent)({
            size: buttonSize,
            pxSize: new Vector2(256 * buttonSize.x / buttonSize.y * this.options.window.pxScale, 256 * this.options.window.pxScale),
            text: {
                value: this.options.text,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '120px',
                    color: styleConfig.text.color.getStyle()
                },
                margin: 0.001,
                lineHeight: 160,
            },
            background: {
                // color: 'transparent'
                // color: 'blue'
                color: styleConfig.backColor.getStyle()
            }
        }));
        this.background = new WindowComponent({
            size: this.resultSize.clone().addScalar(-this.resultSize.y / 10),
            bordRadius: buttonSize.y / 5,
            background: styleConfig.backColor.getHex()
        });
        this.background.uiObject.position.z = -0.0001;
        this.addObject(this.background);
        this.backgroundBorder = new WindowComponent({
            size: this.resultSize,
            bordRadius: buttonSize.y / 5,
            background: styleConfig.shadowColor.getHex()
        });
        this.backgroundBorder.uiObject.position.z = -0.0002;
        this.addObject(this.backgroundBorder);
    }
}
